"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var ContextMenu_meta_1 = require("../ContextMenu.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

var Pill_1 = __importDefault(require("../../Pill"));

var ContextMenuPill = function ContextMenuPill(props) {
  return react_1.default.createElement(Pill_1.default, __assign({}, props));
};

exports.default = InjectedStyledComponent_1.InjectedStyledComponent(ContextMenuPill, ContextMenu_meta_1.CONTEXT_MENU_CATEGORY_KEY, ContextMenu_meta_1.CONTEXT_MENU_COMPONENT_KEY, ['contextMenuPill']);